import styled from 'styled-components';

export const StyledButtonFooter = styled.div`
    height: auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: ${(props) => props.theme.spacing(2)};
`;

export const InvalidPreviewGroup = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: ${(props) => props.theme.spacing(2)};
`;
